import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(others)/terms-of-service/page.tsx");
